// src/_utils/deviceDetector.js

/**
 * Rileva se il dispositivo è Apple (iPhone, iPad, iPod, Mac con touch)
 */
export const isAppleDevice = () => {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isMac = /macintosh/.test(ua) && navigator.maxTouchPoints > 0;
  return isIOS || isMac;
};

/**
 * Rileva se il dispositivo è Google (Android o Chrome OS)
 * Esclude Apple (perché Safari su iOS non è Google)
 */
export const isGoogleDevice = () => {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent.toLowerCase();
  // Solo Android o Chrome OS, esclude Apple
  return (/android/.test(ua) || /crOS/.test(ua)) && !isAppleDevice();
};

/**
 * Rileva se è un PC (Windows, Linux, Mac desktop senza touch)
 * Esclude Apple (perché Mac con touch è Apple) e Google (Android/Chrome OS)
 */
export const isPcDevice = () => {
  if (typeof window === 'undefined') return false;
  return !isAppleDevice() && !isGoogleDevice();
};

/**
 * Rileva se è un dispositivo mobile (screen width < 768px)
 */
export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768;
};